<template>
  <section class="w-full max-w-full sm:max-w-md mx-auto px-4 py-6 space-y-10">
    <FitranaIntro :amount="perPersonAmount" />

    <FitranaCalculator :amount="perPersonAmount" />

    <FitranaAmounts />

    <FitranaInfo />

    <FitranaFaqs />

    <FitranaDisclaimer />

    <InternalLinks current="fitrana" />
  </section>
</template>

<script setup lang="ts">
import InternalLinks from "@/components/seo/InternalLinks.vue";
/**
 * Update once per year
 * (later you can move this to config or a composable)
 */
const perPersonAmount = 300;

  import { seoConfig } from "@/config/seo.config";

useHead({
  title: seoConfig.fitrana.title,
  meta: [
    {
      name: "description",
      content: seoConfig.fitrana.description,
    },
  ],
  link: [
    {
      rel: "canonical",
      href: seoConfig.fitrana.canonical,
    },
  ],
});
</script>
